import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Organization } from "../../../core/models/entities/Organization";

interface CustomerTooltipProps {
  customer?: Organization | null;
}

export default function CustomerTooltip({ customer }: CustomerTooltipProps) {
  const { t } = useTranslation();
  const name = customer?.name ?? "";
  const navNumber = customer?.navNumber ?? "";
  const tooltipTitle = customer
    ? customer.isVendor
      ? `${name} (${navNumber})`
      : name
    : t("compMisc.customerInfoUnavailable");

  return (
    <Tooltip title={tooltipTitle} placement={"top-start"}>
      <span className={"whitespace-nowrap overflow-x-hidden overflow-ellipsis"}>
        {name}
      </span>
    </Tooltip>
  );
}
